import { Navigate, Outlet } from 'react-router-dom';

import { Loader } from '../../shared/Loader';
import { LocalRoutes } from '../../../utilities/LocalRoutes';
import { QuadSecureLayout } from './QuadSecureLayout';
import { useAuthContext } from '../../../contexts/AuthContext';
import { useSignalRContext } from '../../../contexts/SignalRContext';

const QuadSecureRoute = () => {
    const { isInitialized, isLoadingUser, isLoggedIn, user } = useAuthContext();
    const { alertHub } = useSignalRContext();
    if (!isInitialized && isLoadingUser) {
        return <Loader />;
    }

    return isLoggedIn && isInitialized ? (
        <QuadSecureLayout
            alertHubConnection={alertHub}
            isLoggedIn={isLoggedIn}
            user={user ?? { active: false }}
        >
            <Outlet />
            {isLoadingUser && <Loader />}
        </QuadSecureLayout>
    ) : (
        <Navigate to={LocalRoutes.Login} />
    );
};

export default QuadSecureRoute;
